import {MakeDialog} from "../../components/Shared/MakeDialog";
import React, {Component} from "react";
import {Button, Col, FormGroup, Input, Label, Row} from "reactstrap";
import {getFormFieldValue} from "../Applications/shared/shared";
import {postData} from "../../api/doLogin";
import {EventClient} from "../../util/eventClient";

export class ChangePasswordDialog extends Component {
  constructor(props) {
    super(props);
    this.state = {
      currentPassword: "",
      newPassword: "",
      newPassword2: "",
    }
  }

  updatePass() {
    postData(`/account/password`, {currentPassword: this.state.currentPassword, newPassword: this.state.newPassword})
      .then((data) => {
        if (data.status === "Success") {
          EventClient.emit("TOAST_SUCCESS", data.message);
          this.props.onSave && this.props.onSave();
        } else {
          EventClient.emit("TOAST_ERROR", data.message);
        }
      })
      .catch((err) => {
        EventClient.emit("TOAST_ERROR", err.message);
        console.error(err);
      });
  }

  render() {

    return (
      <MakeDialog isOpen={true}
                  className={"ChangePasswordDialog"}
                  footer={<div>
                    <Button color={"primary"}
                            disabled={this.state.currentPassword.length === 0 || this.state.newPassword.length === 0 || this.state.newPassword.length < 8 || this.state.newPassword !== this.state.newPassword2}
                            onClick={() => this.updatePass()}>Update</Button>
                    <Button onClick={() => this.props.onClose && this.props.onClose()}>Cancel</Button>
                  </div>}
                  header="Change Password...">
        <Row>
          <Col xs={12} lg={6}>
            <FormGroup>
              <Label for="currentPassword">Current Password</Label>
              <Input type="password" id="currentPassword" placeholder=""
                     value={getFormFieldValue(this.state.currentPassword)}
                     onChange={(evt) => this.setState({currentPassword: evt.target.value})}/>
            </FormGroup>
          </Col>
        </Row>
        <Row>
          <Col xs={12} lg={6}>
            <FormGroup>
              <Label for="newPassword">New Password</Label>
              <Input type="password" id="newPassword" placeholder=""
                     value={getFormFieldValue(this.state.newPassword)}
                     onChange={(evt) => this.setState({newPassword: evt.target.value})}/>
            </FormGroup>
          </Col>
        </Row>
        <Row>
          <Col xs={12} lg={6}>
            <FormGroup>
              <Label for="newPassword2">Verify Password</Label>
              <Input type="password" id="newPassword2" placeholder=""
                     value={getFormFieldValue(this.state.newPassword2)}
                     valid={this.state.newPassword === this.state.newPassword2}
                     onChange={(evt) => this.setState({newPassword2: evt.target.value})}/>
            </FormGroup>
          </Col>
        </Row>
      </MakeDialog>
    )
  }
}


// WEBPACK FOOTER //
// ./src/containers/Account/ChangePasswordDialog.js